import React, { useEffect, useMemo, useState } from 'react';
import { Container, Option, OptionWrapper, Title, DownIcon, Table, UpIcon, SiteLogo } from './styled';
import { filterBanedSites, siteInfo } from 'components/match/layout/OddsWrapper/Odds/IntegrationOdds/util';

const InternationalOdds = ({ data, gameData }) => {
  const [selectedTab, setSelectedTab] = useState('1X2');
  const [selectedOdds, setSelectedOdds] = useState([]);

  useEffect(() => {
    if (data.odds) {
      setSelectedOdds(filterBanedSites(data.odds, selectedTab));
    }
  }, [selectedTab, data.loading]);

  const handleChangeTab = (tab) => {
    setSelectedTab(tab);
  };
  return (
    <Container>
      <Title>
        배당 현황
        <OptionWrapper>
          <Option isSelected={selectedTab === '1X2'} onClick={() => handleChangeTab('1X2')}>
            일반
          </Option>
          <Option isSelected={selectedTab === 'HANDICAP'} onClick={() => handleChangeTab('HANDICAP')}>
            핸디캡
          </Option>
          <Option isSelected={selectedTab === 'OVERUNDER'} onClick={() => handleChangeTab('OVERUNDER')}>
            언더/오버
          </Option>
        </OptionWrapper>
      </Title>

      <Table>
        <colgroup>
          <col width={186} />
          <col width={100} />
          <col width={100} />
          <col width={100} />
          <col width={100} />
          <col width={54} />
        </colgroup>
        <thead>
          <tr>
            <th></th>
            <th>기준</th>
            <th>{selectedTab === 'OVERUNDER' ? '언더' : '승'}</th>
            <th>무</th>
            <th>{selectedTab === 'OVERUNDER' ? '오버' : '패'}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {selectedOdds.map((odds) => (
            <OddsRow key={odds.oddsSite + selectedTab} data={odds} type={selectedTab} />
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

const OddsRow = ({ data, title, key }) => {
  const { oddsSite, marketType, win, draw, loss, line, winStatus, lossStatus, drawStatus } = data;

  const site = siteInfo.hasOwnProperty(oddsSite) ? siteInfo[oddsSite] : null;

  return [
    <tr key={key}>
      <td>
        {site !== null ? (
          <a href={site.url} target='_blank' rel='noopener noreferrer'>
            <SiteLogo siteLogo={site.name} />
          </a>
        ) : (
          oddsSite
        )}
      </td>
      <td>
        <em className={marketType === 'OVERUNDER' ? 'OVERUNDER' : ''}>{marketType !== '1X2' && !!line && line}</em>
      </td>
      <td>
        {win}
        {winStatus === 'UP' && <UpIcon />}
        {winStatus === 'DOWN' && <DownIcon />}
      </td>
      <td>
        {draw}
        {drawStatus === 'UP' && <UpIcon />}
        {drawStatus === 'DOWN' && <DownIcon />}
      </td>
      <td>
        {loss}
        {lossStatus === 'UP' && <UpIcon />}
        {lossStatus === 'DOWN' && <DownIcon />}
      </td>
    </tr>,
  ];
};

export default InternationalOdds;
